import { ROUTES } from '../constants/routes'
import type { TopicResource } from '../types/api'

/**
 * Edit-page URL for a resource, resolved from whichever scope owns it. Topic
 * scope wins when both ids are present — a topic resource is only reachable
 * under its topic. Returns null for a resource with neither, which the API
 * shouldn't produce but the type allows.
 */
export function resourceEditUrl(r: TopicResource): string | null {
  if (r.topic_id != null) return ROUTES.topicResourceEdit(r.topic_id, r.id)
  if (r.workspace_id != null) return ROUTES.resourceEdit(r.workspace_id, r.id)
  return null
}
